<figure class="flex max-w-378 items-start gap-12 md:items-center">
    <ui-m000-c010-image
        class="block size-96 shrink-0 self-start"
        [image]="{
            image: data().image.url,
            desktop: { width: 96, height: 96 },
            tablet: { width: 96, height: 96 },
            mobile: { width: 96, height: 96 },
        }"
        [priority]="isFirstView()"
        [alt]="data().image.alt ?? ''"
        classList="w-full size-[96px] aspect-square rounded-full"
        focusFace
        highRes
    />
    <div class="flex-1 overflow-hidden">
        <figcaption class="font-headline text-16 leading-27 font-medium text-black">{{ data().name }}</figcaption>
        @if (data().position) {
            <span class="text-back font-text text-14 -mt-4 leading-21">{{ data().position }}</span>
        }
        @if (showPhone() && data().phone) {
            <a
                class="font-headline text-16 text-accent hover:text-blue block leading-27 font-medium"
                [hyundaiRouterLink]="`tel:${data().phone}`"
            >
                {{ data().phone }}
            </a>
        }
        @if (showMail() && data().email) {
            <a
                class="font-headline text-16 text-accent hover:text-blue block truncate leading-27 font-medium"
                [ngClass]="{ '-mt-4': data().phone }"
                [hyundaiRouterLink]="`mailto:${data().email}`"
            >
                {{ data().email }}
            </a>
        }
    </div>
</figure>
